import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {message} from 'antd';
import {AxiosError, AxiosResponse} from 'axios';
import {ADD_CHARGER, UPDATE_CHARGER} from './chargers.type';
import type FILTERS from '../../../../common/filters.type';

import chargersServices from './chargersServices';

const initialState = {
  isLoading: false,
  chargers: {
    page_size: 10,
    page_number: 1,
    sort_by: 'name',
    ascending: true,
    search: '',
    is_active: undefined as undefined | boolean,
    totalDataCount: 0,
    pageData: [],
  },
};

export const chargersList = createAsyncThunk('chargerList', async (payload: FILTERS, thunkAPI) => {
  try {
    const data: AxiosResponse = await chargersServices.chargersList(payload);

    return data;
  } catch (error) {
    const result = error as AxiosError;

    return thunkAPI.rejectWithValue(result.message);
  }
});

export const addCharger = createAsyncThunk('addCharger', async (values: ADD_CHARGER, thunkAPI) => {
  try {
    const data: AxiosResponse = await chargersServices.addCharger(values);

    return data;
  } catch (error) {
    const result = error as AxiosError;

    return thunkAPI.rejectWithValue(result.message);
  }
});
export const updateCharger = createAsyncThunk(
  'updateCharger',
  async (
    values: {
      payload: UPDATE_CHARGER;
      id: number;
    },
    thunkAPI,
  ) => {
    try {
      const data: AxiosResponse = await chargersServices.updateCharger({
        payload: values.payload,
        id: values.id,
      });

      return data;
    } catch (error) {
      const result = error as AxiosError;

      return thunkAPI.rejectWithValue(result.message);
    }
  },
);

export const chargersSlice = createSlice({
  name: 'chargers',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    pageNumberChange(state, action: PayloadAction<number>) {
      state.chargers.page_number = action.payload;
    },
    pageSizeChange(state, action: PayloadAction<number>) {
      state.chargers.page_number = 1;
      state.chargers.page_size = action.payload;
    },
    searchBy(state, action: PayloadAction<string>) {
      state.chargers.page_number = 1;
      state.chargers.search = action.payload;
    },
    sortBy(state, action: PayloadAction<{ascending: boolean; sortBy: string}>) {
      state.chargers.ascending = action.payload.ascending;
      state.chargers.sort_by = action.payload.sortBy;
    },
    chargersStatusFilter(state, action: PayloadAction<boolean | undefined>) {
      state.chargers.page_number = 1;
      state.chargers.is_active = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(chargersList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(chargersList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.chargers = action.payload.data;
    });
    builder.addCase(chargersList.rejected, (state, action) => {
      state.isLoading = false;
      state.chargers = initialState.chargers;
      message.error(`${action.payload}`);
    });

    builder.addCase(addCharger.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addCharger.fulfilled, (state) => {
      state.isLoading = false;
      message.success(`charger added Successfully`);
    });
    builder.addCase(addCharger.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });

    builder.addCase(updateCharger.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateCharger.fulfilled, (state) => {
      state.isLoading = false;
      message.success(`charger updated Successfully`);
    });
    builder.addCase(updateCharger.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });
  },
});
export const {pageNumberChange, pageSizeChange, searchBy, sortBy, chargersStatusFilter} =
  chargersSlice.actions;

export default chargersSlice.reducer;
